module.exports = __webpack_public_path__ + "static/media/Loader.e02a51f8.svg";